import { Injectable } from '@angular/core';
import { ResourceBaseUrlBuilder } from '@core/api/resource-base-url-builder';
import { IssuingNamespacedResourceBaseUrlBuilder } from '@core/issuing-namespaced-resource-base-url-builder.service';
import { ProductNamespacedResourceBaseUrlBuilder } from '@core/product-namespaced-resource-base-url-builder.service';
import { AppStoreQuery, DetailContext } from '@core/state';
import { standardizeUrl } from '@core/utils';
import { issuingProcessRoute, issuingRoute, productRoute } from '@shared/shared-routes';

@Injectable({ providedIn: 'root' })
export class DataroomResourceBaseUrlBuilder implements ResourceBaseUrlBuilder {
  constructor(
    private appStoreQuery: AppStoreQuery,
    private productUrlBuilder: ProductNamespacedResourceBaseUrlBuilder,
    private issuingUrlBuilder: IssuingNamespacedResourceBaseUrlBuilder,
  ) {}

  public buildBaseUrl(): string {
    const detailContext = this.appStoreQuery.getValue().currentDetailContext;

    const builders = new Map<DetailContext, ResourceBaseUrlBuilder>([
      [productRoute, this.productUrlBuilder],
      [issuingProcessRoute, this.issuingUrlBuilder],
      [issuingRoute, this.productUrlBuilder],
    ]);

    const url = builders.get(detailContext)?.buildBaseUrl();
    return standardizeUrl(url);
  }
}
